import {View} from 'MWC';
import tpl from '../templates/PromotionalOffer.jsx';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            isImageOverflow: null,
            isStateChanged: false
        };
        this.blockRef = React.createRef();
        this.imgRef = React.createRef();
        this.findOfferByEnvironment = this.findOfferByEnvironment.bind(this);
    }

    componentDidMount() {
        this.checkImageOverflow();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.isStateChanged) {
            this.checkImageOverflow();
        }
    }

    checkImageOverflow() {
        const block = this.blockRef.current;
        const img = this.imgRef.current;

        if (block && img) {
            const blockHeight = block.getBoundingClientRect().height;
            const imgHeight = img.getBoundingClientRect().height - 42;

            const isOverflow = imgHeight > blockHeight;

            if (this.state.isImageOverflow !== isOverflow) {
                this.setState({
                    isImageOverflow: isOverflow,
                    isStateChanged: true
                });
            } else {
                this.setState({isStateChanged: false});
            }
        }
    }

    findOfferByEnvironment(offers) {
        if (offers) {
            if (window.location.href.includes('a-bank.com.ua')) {
                return offers.find(offer => offer.prod === true);
            } else {
                return offers.find(offer => offer.release === true);
            }
        }
    }
}
